import { cubicOut } from 'svelte/easing';
import type { fade } from 'svelte/transition';

type SvelteAnimation = typeof fade;

/*
 * Makes the element fade in and slide down when it enters the DOM.
 */
export const slidefade: SvelteAnimation = (_, params) => ({
	delay: params?.delay || 0,
	duration: params?.duration || 400,
	easing: params?.easing || cubicOut,
	css: (t: number, u: number) => `opacity: ${t}; transform: translateY(-${u * 20}px);`
});
